
<mat-dialog-content>
  
    <div class="so-confirm mb-3">
        <h3 class="fs-5 mt-3">Do you want to proceed?</h3>
        <p class="">You have not completed mandatory fields</p>
    </div>
    
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-raised-button mat-dialog-close>No, Stay on Page</button>
  <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Proceed</button>
</mat-dialog-actions>